import { plaintextValidator } from '../fields';
import ruleBuilder from '../utils/RuleBuilder';

const config = { mandatory: true };

export default {
  name: plaintextValidator(config),
  policyCategoryId: plaintextValidator(config),
  // viewSubType: plaintextValidator(config), // FIX: Will enable this valiadtion one SNMP released
  ...ruleBuilder('ruleCondition.operands')
};
